:host {
  display:none;
  position: absolute;
  z-index: 1003;
}

* {
  box-sizing: border-box;
}

:host(.loaded) {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: var(--cwc-color-secondary, #333F48);
  padding-right: 0rem;
  padding-left: 0rem;
  font-size: 1rem;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  transition: all var(--cwc-transition-speed, 50ms) ease-in-out;
}

a,
a:visited,
a:active {
  color: inherit !important;
}

/* a:hover {
  color: var(--cwc-color-accent-a, #009A44) !important;
} */

.list-none {
  list-style-type: none;
}

header {
  width: 100%;
  height: 60px;
  background-color: var(--cwc-color-secondary, #333F48);
}

.header-inner {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 5px 2rem;
}

.header-inner__left {
  display: flex;
  gap: 1rem;
}

.header__logo {
  display: grid;
  place-items: center;
  text-decoration: none;
}

.header__logo img {
  max-width: 100%;
}

.header-icons-wrapper {
  display: none;
  margin-left: auto;
}

.nav-toggle {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: 0;
  background-color: rgba(255,173,0,0);
  transition: all var(--cwc-transition-speed, 50ms);
  cursor: pointer;
  border: 1px solid var(--cwc-color-secondary-700, #fff);
  border-radius: 4px;
  color: var(--cwc-color-white);
}

:host(.active) .nav-toggle {
  color: var(--cwc-color-secondary);
  background-color: var(--cwc-color-white, #FFAD00);
}

.nav-toggle div {
  position: relative;
  width: 30px;
  height: 30px;
  pointer-events: none;
}

.nav-toggle span {
  display: block;
  position: absolute;
  height: 4px;
  width: 30px;
  background-color: var(--cwc-color-white, #fff);
  border-radius: 2px;
  opacity: 1;
  left: 0;
  pointer-events: none;
  transition: all var(--cwc-transition-speed, 50ms);
}

.nav-toggle span:first-child {
  top: 2px;
}

:host(.active) .nav-toggle span:first-child {
  rotate: 135deg;
  top: 15px;
  background-color: var(--cwc-nav-toggle-active-icon-color, #333F48);
}

.nav-toggle span:nth-child(2) {
  top: 13px;
}

:host(.active) .nav-toggle span:nth-child(2) {
  rotate: 359deg;
  opacity: 0;
}

.nav-toggle span:last-child {
  top: 24px;
}

:host(.active) .nav-toggle span:last-child {
  rotate: -135deg;
  top: 15px;
  background-color: var(--cwc-nav-toggle-active-icon-color, #333F48);
}

.dropdown-container {
  position: absolute;
  top: 60px;
  width: 100vw;
  display: flex;
  transition: all 150ms;
  transform: translateX(-100vw);
  overflow-x: hidden;
}

.dropdown-container .icons-wrapper a {
  text-decoration: none;
}

:host(.active) .dropdown-container {
  display: flex;
  flex-wrap: no-wrap;
  transform: translateX(0);
}

.icons-wrapper {
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: 45px;
  padding-right: 45px;
  background-color: var(--cwc-color-primary, #FFAD00);
}

.icons-wrapper__icon:not(:first-child) {
  margin-left: 48px;
}

.icons-wrapper__icon.icons-wrapper__sign-in {
  margin-left: auto;
}

.column-1 {
  flex-shrink: 0;
  width: 100vw;
  margin: 0;
  padding: 0;
  color: var(--cwc-color-secondary-900, #242424);
  background-color: var(--cwc-color-white, #fff);
}

.column-1 li {
  border-bottom: 1px solid #858c91;
}

.column-1 li a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  padding: 0 45px;
  color: var(--cwc-color-secondary-900, #242424);
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  text-transform: uppercase;
  text-decoration: none;
}

.column-1 li a:hover {
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
}

.column-1 li a span,
.column-1 li a svg {
  pointer-events: none;
}

.mid-container {
  background-color: rgb(230, 232, 232);
}

.mid-container .sub-title {
  display: flex;
  align-items: center;
  padding: 22.5px 45px 20px;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
  text-transform: uppercase;
  color: var(--cwc-color-secondary-900, #242424) !important;
  background-color: var(--cwc-color-white, #fff);
  text-decoration: none;
}

.mid-container .sub-title svg {
  rotate: 180deg;
  margin-top: 2px;
  margin-right: 1rem;
}

.column-2-3__item:not(.active) {
  display: none;
}

.column-2-3__item {
  display: flex;
  flex-direction: column;
}

.column-2 {
  margin: 0;
  padding: 16px 0;
  font-size: 18px;
}

.column-2 h3 {
  margin: 0;
  padding: 16px 45px;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
  font-size: 18px;
  line-height: 16.875px;
  color: var(--cwc-color-secondary-900, #242424) !important;
}

.column-2.type-2 ul {
  padding-left: 0;
}

.column-2 li a {
  display: flex;
  align-items: center;
  padding: 16px 45px;
  color: var(--cwc-color-secondary-900, #242424) !important;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  text-decoration: none;
  transition: color 100ms;
}

.column-2 li a > span {
  margin-bottom: -5px;
}

.column-2 li a img {
  margin-right: 15px;
  flex-shrink: 0;
}

.column-2.type-2 li a h3 {
  padding: 0;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
}

.column-2.type-2 li hr {
  display: none;
}

.column-2.type-2 li div {
  display: none;
}

.column-2__cta {
  padding: 0 45px;
}

.column-2__cta-content-wrapper,
.column-2__cta-content-wrapper-with-hr {
  padding-bottom: 30px;
}

.column-2__cta-content-wrapper-with-hr {
  padding-top: 30px;
  border-top: 1px solid var(--cwc-color-secondary-200, #FFCCCC);;
}

.column-2__cta-title {
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
  font-size: 18px;
  color: var(--cwc-color-secondary-900, #242424) !important;
}

.column-2__cta-content {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  gap: 15px;
}

.column-2__cta-content p {
  margin: 0;
}

.column-2__cta-content a {
  text-decoration: none;
}

.column-2__cta-link {
  display: block;
  margin-top: 64px;
  font-size: 16.875px;
  color: var(--cwc-color-secondary-900, #242424) !important;
  text-decoration: none;
}

.column-2__cta-link:hover {
  color: var(--cwc-nav-hover-text-color) !important;
}

.green-cta {
  width: 100vw;
  padding: 30px 45px 45px;
  align-items: flex-start;
  border-radius: 0;
  text-align: left;
  color: var(--cwc-color-white, #fff);
  background-color: var(--cwc-nav-cta-bg, #0FC373);
  position: relative;
  background-image: var(--cwc-nav-cta-img-bg);
  background-repeat: no-repeat;
  background-position: 100% 81%;
  background-size: 91%;
  justify-content: var(--cwc-nav-cta-justify);
}

.green-cta .img-wrapper,
.green-cta hr {
  display: none;
}

.green-cta h3 {
  margin: 0;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
  font-size: 24px;
}

.green-cta p {
  margin-bottom: 20px;
  line-height: 1.5;
}

.green-cta .content-wrapper ul {
  list-style-type: none;
  padding-left: 0;
}

.green-cta a.not-button {
  font-size: 18px;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
  text-decoration: none;
  transition: all 100ms;
}

.green-cta__description {
  font-size: 16.875px;
  line-height: 1.5;
}

/* Tooltip */
[data-toggle=tooltip]{
  display: inline;
  position: relative;
  justify-content: center;
}
[data-toggle=tooltip]:hover:after{
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  background: var(--cwc-color-primary, #FFAD00);
  border-radius: 0.25rem;
  color: var(--cwc-color-white, #fff);
  content: attr(title);
  position: absolute;
  bottom: -55px;
  white-space: pre;
  z-index: 2;
  padding: 15px;
  font-size: 12px;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
  max-width: 200px;
  text-align: center;
}

[data-toggle=tooltip]:hover:before{
  border: solid;
  border-color: var(--cwc-color-primary, #FFAD00) transparent;
  border-width: 8px 8px 0px;
  content: "";
  bottom: -12px;
  position: absolute;
  transform: rotate(180deg);
}
/* end Tooltip */

.header-icons-wrapper__phone[data-toggle=tooltip]:hover:after{
  font-size: 18px;
  bottom: -57px;
  padding: 15px 15px 9px;
}

@media (max-width: 767px) and (min-width: 320px) {
  .header-icons-wrapper__phone[data-toggle=tooltip]:hover:after{
    left: 0;
  }
  /* Nav Icons */
  .dropdown-container .icons-wrapper {
    justify-content: space-between;
  }
  .dropdown-container .header-icons-wrapper {
      display: flex;
      align-items: center;
  }
    .dropdown-container .header-icons-wrapper__phone, .dropdown-container .header-icons-wrapper__search, .dropdown-container .header-icons-wrapper__language, .dropdown-container .header-icons-wrapper__sign-in {
      display: flex;
      align-items: center;
  }
    .dropdown-container .header-icons-wrapper__phone, .dropdown-container .header-icons-wrapper__search, .dropdown-container .header-icons-wrapper__language {
      padding: 5px;
      margin-right: 5px;
  }
    .dropdown-container .header-icons-wrapper__language {
      display: flex;
      align-items: center;
      justify-content: center;
  }
    .dropdown-container .header-icons-wrapper__language:hover .staticMap {
      display: var( --language-icon-hover-display );
  }
    .dropdown-container .header-icons-wrapper__language:hover {
      text-decoration: none !important;
  }
    .dropdown-container .header-icons-wrapper__language:hover .map-details svg path {
      fill: var(--cwc-color-white, #fff);
  }
    .dropdown-container .header-icons-wrapper__search:hover svg circle, .dropdown-container .header-icons-wrapper__phone:hover svg path {
      stroke: var(--cwc-color-white, #fff);
  }
    .dropdown-container .header-icons-wrapper__search:hover svg rect {
      fill: var(--cwc-color-white, #fff);
  }
    .dropdown-container .header-icons-wrapper__phone:hover svg path {
      fill: none !important;
  }
    .dropdown-container .header-icons-wrapper__language .staticMap {
      display: block;
      position: relative;
      margin-left: 0;
      height: 28px;
      width: 28px;
  }
    .dropdown-container .header-icons-wrapper__language .staticMap svg:nth-child(2) {
      position: absolute !important;
      left: 3px !important;
      top: 4px !important;
      border-radius: 100%;
  }
    .dropdown-container .header-icons-wrapper__language .map-details {
      display: none !important;
  }

    .dropdown-container .hidden {
      display: none;
  }
    .dropdown-container .header-icons-wrapper__icon:hover {
      color: var(--cwc-color-white, #fff) !important;
  }
    .dropdown-container .header-icons-wrapper__icon:hover svg g, .dropdown-container .header-icons-wrapper__icon:hover svg path {
      fill: var(--cwc-color-white, #fff);
  }
    .dropdown-container .header-icons-wrapper__sign-in {
      display: flex;
      align-items: center;
      margin-left: 10px;
      color: var(--cwc-color-white, #fff) !important;
      font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
      font-weight: 400;
      font-size: 15px;
      text-decoration: none;
  }
    .dropdown-container .header-icons-wrapper__sign-in span {
      margin-left: 5px;
      color: inherit;
  }

  /* end Nav Icons */
}

@media (min-width: 768px) {
  .header__logo{
    width: calc(328px - calc(328px * 0.20));
  }
  .header__logo::before{
    margin-top: 0;
  }
/* Nav Icons */

  .header-icons-wrapper {
    display: flex;
    align-items: center;
  }

  .header-icons-wrapper__phone,
  .header-icons-wrapper__search,
  .header-icons-wrapper__language,
  .header-icons-wrapper__sign-in{
    display: flex;
    align-items: center;
  }

  .header-icons-wrapper__phone,
  .header-icons-wrapper__search,
  .header-icons-wrapper__language{
    padding: 5px;
    margin-right: 5px;
  }
  .header-icons-wrapper__language {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-icons-wrapper__language:hover .staticMap {
    display: var( --language-icon-hover-display );
  }
  .header-icons-wrapper__language:hover .white-globe {
    width: 28px;
    height: 28px;
    display: var(--language-icon-svg-hover-display);
    background-image: url(https://cradlepoint.com/wp-content/uploads/2021/05/globe-cp__cp-yellow@4x.gif);
    background-size: contain;
    background-repeat: no-repeat;
  }
  .header-icons-wrapper__language:hover {
    text-decoration: none !important;
  }
  .header-icons-wrapper__language:hover .map-details svg path {
    fill: var(--cwc-color-white, #fff);
  }

  .header-icons-wrapper__search:hover svg circle,
  .header-icons-wrapper__phone:hover svg path{
  stroke: var(--cwc-color-primary, #FFAD00);
  }
  .header-icons-wrapper__search:hover svg rect{
  fill: var(--cwc-color-primary, #FFAD00);
  }
  .header-icons-wrapper__phone:hover svg path{
  fill: none !important;
  }

 .header-icons-wrapper__language .staticMap{
    display: block;
    position: relative;
    margin-left: 0;
    height: 28px;
    width: 28px;
  }

  .header-icons-wrapper__language .staticMap svg:nth-child(2) {
    position: absolute!important;
    left: 3px!important;
    top: 4px!important;
    border-radius: 100%;
  }

  .header-icons-wrapper__language .map-details{
    margin-left: 10px;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 3px;
    padding: 0;
  }

  .header-icons-wrapper__language .map-details p{
    font-size: 14px;
    font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
    font-weight: 400;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: var(--cwc-color-white, #fff);
    margin-bottom: 0;
    margin-top: 0;
    display: flex;
    align-items: center;
  }
  .header-icons-wrapper__language .map-details span{
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #adb2b5;
    font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
    font-weight: 400;
  }

  .header-icons-wrapper__language .map-details svg{
    margin-left: 5px;
    fill: var(--cwc-color-white, #fff);
    width: 14px;
  }

  .hidden{
    display: none;
  }

  /* .header-icons-wrapper__icon:hover {
    color: var(--cwc-color-primary, #FFAD00) !important;
  } */

  .header-icons-wrapper__icon:hover svg g,
  .header-icons-wrapper__icon:hover svg path {
    fill: var(--cwc-color-primary, #FFAD00);
  }

  .header-icons-wrapper__sign-in {
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: var(--cwc-color-white, #fff) !important;
    font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
    font-weight: 400;
    font-size: 15px;
    text-decoration: none;
  }

  .header-icons-wrapper__sign-in span {
    margin-left: 5px;
    color: inherit;
  }

/* end Nav Icons */

  .icons-wrapper {
    display: none;
  }

  .column-1-container {
    flex-shrink: 0;
    width: clamp(250px, 35%, 270px);
  }

  .column-1 {
    width: 100%;
    height: 100%;
    padding-top: 36px;
    padding-bottom: 36px;
    font-size: 15px;
    background-color: var(--cwc-nav-left-column-bg, #e6e8e8);
  }

  .column-1 li {
    border-bottom: 0;
  }

  .column-1 li a {
    padding-left: 12px;
    padding-right: 12px;
    font-size: var(--cwc-nav-left-column-font-size, 18px);
    text-transform: var(--cwc-nav-left-column-text-transform, uppercase);
  }

  .column-1 li a.active {
    font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
    font-weight: 400;
    background-color: var(--cwc-color-white, #fff);
  }

  .green-cta.green-cta__mobile-default {
    display: none;
  }

  .column-2-3__container {
    width: auto;
  }

  .column-2-3__item {
    justify-content: space-between;
    height: 100%;
  }

  .mid-container {
    flex-grow: 1;
    background-color: var(--cwc-color-white, #fff);
  }

  .mid-container .sub-title {
    display: none;
  }

  .column-2 {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-column-gap: 32px;
    grid-row-gap: 45px;
    height: fit-content;
    padding: 60px 35px 36px;
    background-color: var(--cwc-color-white, #fff);
    font-size: 15px;
  }

  .column-2 li hr {
    width: 25px;
    height: 4px;
    margin: 8.5px auto 8.5px 0;
    background-color: var(--cwc-nav-cta-bg, #0FC373);
    border: 2px solid var(--cwc-nav-cta-bg, #0FC373);
    border-radius: 4px;
    box-sizing: border-box
  }

  .column-2 h3 {
    margin-top: 0;
    margin-bottom: 1.65rem;
    padding: 0;
    font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
    font-weight: 400;
    font-size: 15px;
    line-height: 16.875px;
    color: var(--cwc-color-secondary-900, #242424) !important;
  }

  .column-2 li a {
    padding: 0;
    font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
    font-weight: 400;
  }

  .column-2 li a:hover {
    color: var(--cwc-nav-hover-text-color) !important;
  }

  .column-2.type-2 h3 {
    margin: 0;
    transition: all 100ms;
  }

  .column-2.type-2 a:hover h3 {
    color: var(--cwc-nav-hover-text-color) !important;
  }

  .column-2.type-2 ul {
    margin-top: 25px;
  }

  .column-2.type-2 li a h3 {
    font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
    font-weight: 400;
  }

  .column-2.type-2 p {
    font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
    font-size: 13px;
    line-height: 19.5px;
  }

  .column-2 .has-sub-menu .sub-menu {
    padding-left: 0;
    display: grid;
    row-gap: 1.65rem;
  }

  .column-2 .has-sub-menu .sub-menu li a {
    font-family: var(--cwc-font-sans-serif-light, 'Eina01-Light');
  }

  .column-2__cta {
    padding-left: 35px;
    padding-right: 35px;
  }

  .column-2__cta-title {
    font-size: 15px;
    line-height: 16.875px;
    color: var(--cwc-color-secondary-900, #242424) !important;
  }

  .column-2__cta-content {
    font-size: 14px;
  }

  .column-2__cta-link {
    font-size: 15px;
  }

  .green-cta {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    width: auto;
    height: fit-content;
    padding: 36px 35px;
    font-size: 15px;
    line-height: 22.5px;
  }

  .green-cta .img-wrapper {
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background-color: var(--cwc-color-secondary, #333F48);
    height: 64px;
    width: 64px;
    padding: 15px;
    margin-left: auto;
    margin-right: auto;
  }

  .green-cta .img-wrapper img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .green-cta hr {
    width: 50px;
    height: 4px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: 0;
    background-color: var(--cwc-color-white, #fff);
    border: 2px solid var(--cwc-color-white, #fff);
    border-radius: 4px;
  }

  .green-cta h3 {
    font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
    font-weight: 400;
    margin-top: 0;
  }

  .green-cta a.not-button:hover {
    color: var(--cwc-color-secondary-900, #242424) !important;
    text-decoration: underline;
  }
}

@media (min-width: 1025px) {
  .header__logo::before{
    margin-top: -4px;
  }

  .header-inner__left {
    gap: 1.25rem;
  }

  .header__logo{
    width: unset;
  }

  /* Nav Icons */
  .header-icons-wrapper__phone,
  .header-icons-wrapper__search,
  .header-icons-wrapper__language{
    padding: 10px;
    margin-right: 10px;
    text-decoration: none;
  }
  .header-icons-wrapper__sign-in {
    margin-left: 35px;
  }

  .header-icons-wrapper__sign-in span {
    margin-left: 12px;
  }
  /* Nav Icons */

  :host(.active) header {
    /* border-bottom: 15px solid var(--cwc-nav-toggle-active-background-color, #FFAD00); */
  }

  .header-inner {
    padding-left: 48px;
    padding-right: 48px;
  }

  .nav-toggle {
    padding-block: 0;
  }

  .dropdown-container {
    top: 60px;
    left: 48px;
    max-width: calc(100vw - 96px);
    height: 0;
    overflow: hidden;
    border-radius: 0 0 16px 16px;
    background-color: transparent;
  }

  .dropdown-container,
  :host(.active) .dropdown-container {
    transform: unset;
  }

  :host(.active) .dropdown-container {
    height: initial;
  }

  .column-1-container {
    width: 21.30%;
  }

  .column-2-3__container {
    display: flex;
    width: 78.7%;
    background-color: transparent;
  }

  .column-2-3__item {
    flex-direction: row;
    width: 100%;
    max-width: 1180px;
  }

  .mid-container {
    display: flex;
    flex-direction: column;
    width: 66.57%;
  }

  .column-2 {
    grid-column-gap: 35px;
    grid-row-gap: 65px;
  }

  .column-2 > li.has-border-right {
    border-right: 1px solid var(--cwc-color-secondary-200, #FFCCCC);
  }

  .column-2.type-2 li hr,
  .column-2.type-2 li div {
    display: block;
  }

  .column-2__cta {
    flex-grow: 1;
  }

  .column-2__cta > div {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 200px;
  }

  .column-2__cta-link {
    margin-bottom: 0px;
    margin-top: auto;
  }

  .green-cta {
    flex-direction: column;
    gap: 0;
    width: 33.43%;
    height: auto;
    text-align: center;
    border-radius: 0 0 16px 0;
  }

  .green-cta .img-wrapper {
    height: 82px;
    width: 82px;
  }

  .green-cta h3 {
    margin-top: 15px;
  }

  .green-cta hr {
    margin-top: 23px;
    margin-bottom: 23px;
    margin-left: auto;
  }

  .green-cta p {
    margin-bottom: 40px;
  }
}

@media (min-width: 1280px) {
  .column-1 {
    font-size: 16.5px;
  }

  .column-2.one-third--two-thirds {
    grid-template-columns: 1.5fr 3fr;
  }

  .column-2.one-third--two-thirds .has-sub-menu:last-child .sub-menu {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 35px;
  }

  .column-2__cta-link {
    font-size: 16.5px;
  }
}

@media (min-width: 1440px) {
  .column-1 {
    padding-top: 52px;
    padding-bottom: 52px;
    font-size: 18px;
  }

  .column-1 li a {
    padding-left: 45px;
    padding-right: 20px;
  }

  .column-2 {
    padding-top: 72px;
    padding-bottom: 52px;
    grid-template-columns: repeat(3,1fr);
    font-size: 16px;
  }

  .column-2.two-columns {
    grid-template-columns: repeat(2,1fr);
  }

  .column-2 h3,
  .column-2__cta-title {
    font-size: 18px;
    line-height: 20.25px;
  }

  .column-2__cta-content {
    font-size: 16px;
  }

  .column-2__cta-link {
    font-size: 18px;
  }

  .green-cta h3 {
    font-size: 22px;
  }

  .green-cta p {
    font-size: 18px;
    line-height: 27px;
  }

  .green-cta a.not-button {
    font-size: 24px;
  }
}

@media (min-width: 1550px) {
  .column-1-container {
    width: 21.29%;
  }

  .column-2-3__container {
    width: 78.70%;
  }
}

/*

  Mobile Menu

*/

header.mobile {
  --transition: all 100ms;
}

header.mobile .dropdown-container {
  height: 100vh;
  transition: var(--transition);
}

header.mobile .column-1-container,
header.mobile .column-2-3__container {
  position: absolute;
  transition: var(--transition);
}

header.mobile .column-1-container {
  transform: translateX(0);
}

header.mobile .column-1 li a {
  padding-top: 8px;
}

header.mobile .column-1 li a svg {
  margin-bottom: 5px;
}

header.mobile.level-2 .column-1-container {
  transform: translateX(-100vw);
}

header.mobile.level-3 .column-1-container {
  transform: translateX(-200vw);
}

header.mobile .column-2-3__container {
  transform: translateX(100vw);
}

header.mobile.level-2 .column-2-3__container {
  transform: translateX(0);
}

header.mobile.level-3 .column-2-3__container  {
  transform: translateX(-100vw);
}

header.mobile .column-2-3__container .mid-container .sub-title span {
  padding-top: 3px;
  margin-bottom: -3px;
}

header.mobile .column-2 > li {
  position: relative;
}

header.mobile .column-2 .has-sub-menu .sub-menu {
  display: none;
  position: absolute;
  width: 100vw;
  transform: translateX(100vw);
  background-color: var(--cwc-color-white, #fff);
}

header.mobile .column-2 .has-sub-menu .sub-menu.active {
  display: block;
}

header.mobile .column-2 .has-sub-menu:first-child .sub-menu {
  top: -77px;
}

header.mobile .column-2 .has-sub-menu:nth-child(2) .sub-menu {
  top: calc((30px + (49px * 2)) * (-1));
}

header.mobile .column-2 .has-sub-menu:nth-child(3) .sub-menu {
  top: calc((30px + (49px * 3)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(4) {
  top: calc((30px + (49px * 4)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(5) {
  top: calc((30px + (49px * 5)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(6) {
  top: calc((30px + (49px * 6)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(7) {
  top: calc((30px + (49px * 7)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(8) {
  top: calc((30px + (49px * 8)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(9) {
  top: calc((30px + (49px * 9)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu:nth-child(10) {
  top: calc((30px + (49px * 10)) * (-1));
}

header.mobile .column-2 .has-sub-menu .sub-menu li {
  background-color: rgb(230, 232, 232);
}

header.mobile .column-2 .has-sub-menu .sub-menu li a {
  padding-top: 22.5px;
  padding-bottom: 22.5px;
}

header.mobile .column-2 li a img {
  display: none;
}

/*

  Alt Mobile Layout

*/

header.mobile.alt-mobile-layout .column-2 > li {
  position: unset;
}

header.mobile.alt-mobile-layout .column-2 .has-sub-menu .sub-menu {
  display: block;
  position: unset;
  width: unset;
  transform: unset;
  background-color: unset;
}

header.mobile.alt-mobile-layout .column-2 .has-sub-menu .sub-menu .sub-title  {
  display: none;
}

header.mobile.alt-mobile-layout .column-2 .has-sub-menu .sub-menu li a {
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  padding-top: 14px;
  padding-bottom: 12px;
}

header.mobile.alt-mobile-layout .column-2 li.has-sub-menu:not(:first-child) {
  margin-top: 24px;
}

header.mobile.alt-mobile-layout .column-2 li a {
  padding-top: 14px;
  padding-bottom: 12px;
}

header.mobile.alt-mobile-layout .column-2 li a img {
  display: block;
}

header .globe-icon::before{
  content: '';
  display: block;
  -webkit-mask: var(--language-icon) no-repeat 50% 50%;
  mask: var(--language-icon) no-repeat 50% 50%;
  -webkit-mask-size: cover;
  mask-size: cover;
  height: 28px;
  width: 28px;
  background-color: #fff;
}

.header-icons-wrapper__language:hover .globe-icon::before{
  background-color: var(--language-icon-hover-bg);
}
.dropdown-container .header-icons-wrapper__language:hover .globe-icon::before{
  background-color: var(--cwc-color-white);
}

cradlepoint-button-cta {
  clip-path: unset;
  border-radius: 4px;
  text-transform: unset;

  &::before {
    display: none;
  }
}
